import { Get, Post, Delete } from '../request'

export const listOrdersByCustomer = ({ customerId, accessToken, descending = true }) => {
  const config = {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
    params: {
      customer_id: customerId,
      descending,
    }
  }
  return Get('/orders', config)
}

export const createOrder = (order) => {
  return Post('/orders', order)
}

export const cancelOrder = (id) => {
  return Delete(`/orders/${id}`)
}

export const calcPostage = ({ areaId, lists }) => {
  const params = { lists }
  return Post(`postages/${areaId}`, params)
}
